<div class="py-4 container-fluid curriculum-types-page">
  <h4 class="mb-4 curriculum-types-title">การตั้งค่า - หลักสูตร</h4>

  <div class="curriculum-types-card">
    <div class="curriculum-types-card-body">
      <div class="curriculum-types-toolbar" [formGroup]="form">
        <div class="curriculum-types-filter">
          <app-filter-search-input
            label="หลักสูตร"
            formControlName="keyword"
            inputClass="curriculum-types-search-input"
            classes="mb-0"
            ariaLabel="ค้นหาหลักสูตร"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      <ng-template #rowIndexTemplate let-row="row" let-rowIndex="rowIndex">
        {{ row.sequence ?? curriculumTypes().offset + rowIndex + 1 }}
      </ng-template>

      <app-datatable
        [datasource]="curriculumTypes()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="50"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="curriculumTypes().page"
        [limit]="curriculumTypes().limit"
        [total]="curriculumTypes().total"
        [totalPage]="curriculumTypes().total_page"
        [offset]="curriculumTypes().offset"
        [dataLength]="curriculumTypes().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="Curriculum types pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>
